module.exports = __webpack_public_path__ + "static/media/deploy-scale-monitoring@mobile.0ece022b.svg";